import { useEffect, useRef, useState } from 'react';
import VideoService from '../service/VideoService';
import { ScenesType } from '../../common/apis/CmsAPI';

export default function useWaitForJobsToStart({ onJobsFound, onScenesReady }) {
  const checkTimeout = useRef(null);
  const videosListRef = useRef({});
  const [scenesListUpdated, setScenesListUpdated] = useState(false);

  const pushScenes = newData => {
    newData.forEach(({ videoId, sceneId }) => {
      if (!videosListRef.current[videoId]) {
        videosListRef.current[videoId] = [sceneId];
      } else {
        if (videosListRef.current[videoId].indexOf(sceneId) < 0) {
          videosListRef.current[videoId].push(sceneId);
        }
      }
    });
    setScenesListUpdated(true);
  }

  const checkVideosStatus = async () => {
    for (const videoId in videosListRef.current) {
      if (!videosListRef.current[videoId]?.length) {
        continue;
      }
      const statusCheck = await VideoService.checkStoryStatus(videoId);
      switch (statusCheck.status) {
        case 'PENDING':
          break;
        case 'PROCESSING':
        case 'READY':
          const foundJobs = [];
          console.log('READY Checking jobs for video', videoId);
          const videoJobs = await VideoService.checkSceneJobs(videoId);
          if (videoJobs.hasRunningJobs) {
            videosListRef.current[videoId].map(sceneId => {
              const sceneJobs = videoJobs.runningJobs.filter(jobDetails => jobDetails.outputs[0].relatedTo.id == sceneId);
              if (sceneJobs) {
                foundJobs.push(...sceneJobs.filter(({ outputs }) => !outputs.every(({ label }) => label == 'hlsTrimmed')).map(({ jobId }) => ({ sceneId, jobId })));
              }
            });
          }
          if (foundJobs.length) {
            onJobsFound(foundJobs.map(item => item.jobId));
            videosListRef.current[videoId] = videosListRef.current[videoId].filter(sceneId => !foundJobs.find(item => sceneId == item.sceneId));
          }
          if (videosListRef.current[videoId].length > 0) {
            const scenesReady = [];
            const videoDetails = await VideoService.getVideoDetails(videoId, ScenesType.REGULAR);
            const updatedScenes = videoDetails.scenes.filter(({ id }) => videosListRef.current[videoId]?.find(sceneId => sceneId == id)).filter(item => item?.trimmedDuration > 0);
            updatedScenes && scenesReady.push(...updatedScenes);
            if (scenesReady.length) {
              onScenesReady(scenesReady);
              videosListRef.current[videoId] = videosListRef.current[videoId].filter(sceneId => !scenesReady.find(scene => sceneId == scene.id));
            }
          }
          break;
        default:
          break;
      }
      if (videosListRef.current[videoId]?.length == 0) {
        delete videosListRef.current[videoId];
      }
    }
    if (Object.keys(videosListRef.current).length) {
      // If there are more scenes to check, continue checking
      checkTimeout.current = setTimeout(() => checkVideosStatus(), 3000);
    } else {
      checkTimeout.current = null;
    }
  };

  useEffect(() => {
    if (scenesListUpdated) {
      if (!checkTimeout.current && Object.keys(videosListRef.current).length > 0) {
        // Start check
        checkVideosStatus();
      }
      setScenesListUpdated(false);
    }
  }, [scenesListUpdated]);

  useEffect(() => {
    return () => {
      clearTimeout(checkTimeout.current);
      checkTimeout.current = null;
    }
  }, [])

  return {
    pushScenes,
  }
}
